import { render, staticRenderFns } from "./OrderDeliveryEdit.vue?vue&type=template&id=d56e14f2"
import script from "./OrderDeliveryEdit.vue?vue&type=script&lang=js"
export * from "./OrderDeliveryEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports